import { useCurrentUser } from "./useCurrentUser";

export function useCurrentUserProducts() {
  return useCurrentUser()?.apps;
}
